<template>
  <div class="modal-kajabi d-flex flex-column gap-4">
    <snow-select
      id="product-select"
      label="Produto"
      v-model="form.product_id"
      :disabled="isEdit"
      :options="products.map(({ id, name }) => ({ id, name }))"
    />
    <snow-input
      id="url_activation"
      label="Informe a URL para ativação de novo membro"
      v-model="form.url_activation"
      :rules="rules.url_activation"
    />
    <snow-input
      id="url_deactivation"
      label="Informe a URL para desativação de membro"
      v-model="form.url_deactivation"
      :rules="rules.url_deactivation"
    />

    <div class="snow-submit-buttons mt-3">
      <snow-button
        size="lg"
        variant="gray"
        text="Cancelar"
        class="order-lg-0 order-1"
        @click="$emit('close')"
      />
      <snow-button
        size="lg"
        :text="isEdit ? 'Salvar' : 'Integrar'"
        :loading="loading"
        :disabled="!isValid"
        @click="submit"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import IntegrationModalMixin from "@/mixins/integrationModal";
import { required, validUrl } from "@/functions/validation";
export default {
  mixins: [IntegrationModalMixin],
  data() {
    return {
      ...formFields(
        ["product_id", "offer", "url_activation", "url_deactivation"],
        {
          ...this.integrationToEdit,
          product_id: this.integrationToEdit?.product?.id
        }
      )
    };
  },
  computed: {
    focusedProduct() {
      if (!this.form.product_id) {
        return null;
      }
      return this.products.find(p => p.id === this.form.product_id);
    },
    isValid() {
      return (
        this.form.product_id &&
        // this.form.offer !== null &&
        this.form.url_activation &&
        this.form.url_deactivation
      );
    },
    rules() {
      return {
        url_activation: [required(), validUrl()],
        url_deactivation: [required(), validUrl()]
      };
    }
  },
  methods: {
    submit() {
      this.loading = true;
      if (this.integrationToEdit) {
        this.$store
          .dispatch("integration/putKajabi", {
            product_id: this.product_id,
            id: this.integrationToEdit.id,
            ...this.form
          })
          .then(this.onSuccess)
          .catch(() => {
            this.$message.error("Erro ao salvar integração");
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$store
          .dispatch("integration/postKajabi", {
            product_id: this.product_id,
            ...this.form
          })
          .then(this.onSuccess)
          .catch(error => {
            this.$message.error("Erro ao salvar a nova integração");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
};
</script>
